export default function intlLibraryIsPresent() {
  return !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');
}
